export default `
precision highp float;

attribute vec2 aVertexPosition;
attribute vec2 uv;
attribute vec3 normal;
attribute float hexagonTilingIndex;

//Pixi provided
uniform mat3 translationMatrix;
uniform mat3 projectionMatrix;

uniform vec2 lightPos;

varying vec2 vUv;
varying mat3 vNormalMatrix;
//varying vec3 vLightDirection;
varying vec3 vWorldPosition;

varying float vHexagonTilingIndex;
varying float vHexFlag0;
varying float vHexFlag1;
varying float vHexFlag2;
varying float vHexFlag3;
varying float vHexFlag4;
varying float vHexFlag5;

void main() {
	vUv = uv;
	vNormalMatrix = translationMatrix;

	//get just the rotational part. 
	//TODO: This probably won't handle non-uniform rotation correctly,
	//the correct way to do it involves taking the transpose of things see:
	//https://www.lighthouse3d.com/tutorials/glsl-12-tutorial/the-normal-matrix/ and
	//https://learnopengl.com/Advanced-Lighting/Normal-Mapping
	vNormalMatrix[2][0] = 0.0;
	vNormalMatrix[2][1] = 0.0;
	vNormalMatrix[2][2] = 1.0;
	// vNormalMatrix[1][2] = 0.0;
	// vNormalMatrix[2][2] = 0.0;

	vWorldPosition = vec3((translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0);
	vHexagonTilingIndex = hexagonTilingIndex;
	vHexFlag0 = floor(mod(hexagonTilingIndex, 2.0));
	vHexFlag1 = floor(mod(hexagonTilingIndex / pow(2.0, 1.0), 2.0));
	vHexFlag2 = floor(mod(hexagonTilingIndex / pow(2.0, 2.0), 2.0));
	vHexFlag3 = floor(mod(hexagonTilingIndex / pow(2.0, 3.0), 2.0));
	vHexFlag4 = floor(mod(hexagonTilingIndex / pow(2.0, 4.0), 2.0));
	vHexFlag5 = floor(mod(hexagonTilingIndex / pow(2.0, 5.0), 2.0));
	
	gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
}
`
